import React from 'react';
import SearchField from '../searchFiled';
import Suggestions from '../suggestions';
import infoIcon from '../../../../../assets/infoG.svg';

interface IntentSignalSlideProps {
  inputValue: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onSuggestionSelect: (suggestion: string) => void;
  disabled?: boolean;
}

const IntentSignalSlide: React.FC<IntentSignalSlideProps> = ({
  inputValue,
  onChange,
  onSearch,
  onSuggestionSelect,
  disabled
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col w-full bg-[#388E3C] rounded-[9px] mb-[24px] pl-[9px] py-[1px] pr-[1px]">
        <div className="flex items-center text-left gap-2 bg-[#FFFFFF] rounded-r-[8px] px-[4px] py-[4px]">
          <img src={infoIcon} alt="info" className="w-[12px] h-[12px] mr-[4px] text-[#388E3C]" />
          <p className="text-[12px] font-medium text-[#388E3C]">
            Intent signals show what you're looking for based on your interests. Below are some suggestions
          </p>
        </div>
      </div>
      <SearchField 
        value={inputValue} 
        onChange={onChange} 
        onSearch={onSearch}
        disabled={disabled}
      />
      <div className="mt-[14px] rounded-[10px] bg-[#F7F7F7] p-[16px]">
        <p className="text-[12px]  font-light text-[#000000] mb-3 text-left ">
          Or, choose a suggestion below
        </p>
        <Suggestions onSelect={onSuggestionSelect} />
      </div>
    </div>
  );
};

export default IntentSignalSlide; 